export default "__VITE_ASSET__Dw64wOM2__"